import {CASBFileResponse, TransformedFileList} from 'interfaces'
import {getTimeAgo} from 'utils'

export const getTableData = (
  filesData: CASBFileResponse[],
): TransformedFileList[] => {
  const fileList = filesData?.map(file => {
    const {detectionSummary, reviewSummary, fileSummary} = file
    return {
      ...fileSummary,
      ...reviewSummary,
      type: detectionSummary?.classifications.map(
        classification => classification.classificationType,
      ),
      createdOnTimeAgo: getTimeAgo(fileSummary?.createdOn),
      ...(file?.unshareError && {unshareError: file.unshareError}),
    }
  })
  return fileList
}
